import { getEnvironmentConfig } from "@/config/environment";

export interface BusinessUnit {
  id: number;
  name: string;
  address: string;
  code: string;
  created_at: string;
  updated_at: string;
}

export interface Company {
  id: number;
  name: string;
  cif: string;
  address: string;
  provincia: string;
  telefono: number;
  client: number;
  business_unit_count: number;
  business_unit_ids: number[];
  business_unit_names: string[];
  business_unit_codes: string[];
  business_units?: BusinessUnit[]; // Keep for backwards compatibility
}

export interface CompaniesParams {
  limit?: number;
  offset?: number;
  search?: string;
  has_business_units?: boolean;
}

class CompaniesApiService {
  private readonly baseUrl: string;

  constructor() {
    const config = getEnvironmentConfig();
    this.baseUrl = config.apiUrl;
  }

  async getCompanies(params: CompaniesParams = {}): Promise<Company[]> {
    const { limit = 500, offset = 0, search, has_business_units = true } = params;
    
    const queryParams = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString(),
      has_business_units: has_business_units.toString(),
    });
    
    if (search) {
      queryParams.append('search', search);
    }

    try {
      const response = await fetch(
        `${this.baseUrl}/api/v1/companies-fast/?${queryParams.toString()}`,
        {
          mode: 'cors',
          headers: {
            'accept': 'application/json',
            'ngrok-skip-browser-warning': '1',
            'origin': window.location.origin
          }
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch companies: ${response.statusText}`);
      }

      const data = await response.json();
      return data as Company[];
    } catch (error) {
      console.error('Error fetching companies:', error);
      throw error;
    }
  }

  async searchCompanies(searchTerm: string): Promise<Company[]> {
    return this.getCompanies({ search: searchTerm });
  }
}

export const companiesApiService = new CompaniesApiService();